var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1471786_delay_pending_time_timer_wait_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pending_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0001 28.2332C9.002 28.2332 3.31041 22.7313 3.31041 15.9665C3.31041 9.74572 8.12917 4.6044 14.3449 3.81613V1.6604C6.89772 2.4572 1.10352 8.55532 1.10352 15.9665C1.10352 23.9196 7.77276 30.3665 16.0001 30.3665C23.6679 30.3665 29.9763 24.7655 30.7995 17.5665H28.5695C27.754 23.5751 22.4354 28.2332 16.0001 28.2332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.4827 15.4333H17.5536C17.388 14.981 17.0195 14.6247 16.5516 14.4647V5.83325H15.4482V14.4647C14.8071 14.6855 14.3447 15.2711 14.3447 15.9666C14.3447 16.8498 15.0862 17.5666 15.9999 17.5666C16.7193 17.5666 17.3251 17.1197 17.5536 16.4999H26.4827V15.4333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.856 5.09618L22.9638 3.24126C22.1473 2.82206 21.2855 2.4711 20.3862 2.20337L19.8135 4.26952C20.5252 4.48498 21.2049 4.76658 21.856 5.09618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.6621 15.4333H30.869C30.8348 14.517 30.7167 13.6231 30.5137 12.7581L28.3818 13.3106C28.5385 13.9975 28.629 14.7079 28.6621 15.4333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.5604 6.93719L26.1251 5.42466C25.4431 4.81239 24.7049 4.26305 23.9138 3.78198L22.8081 5.63159C23.4327 6.01773 24.0164 6.45612 24.5604 6.93719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.6903 9.38429L28.6048 8.31655C28.1072 7.55175 27.5378 6.83709 26.9055 6.17896L25.3408 7.69149C25.8385 8.21629 26.2909 8.78163 26.6903 9.38429Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.7465 3.99753L19.3181 1.93672C18.4232 1.73939 17.4996 1.62633 16.5518 1.59326V3.72659C17.3021 3.75859 18.0359 3.84606 18.7465 3.99753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.1017 12.2792L30.2391 11.7267C29.9622 10.8574 29.5991 10.0243 29.1644 9.23389L27.2466 10.3048C27.5864 10.9342 27.8777 11.5923 28.1017 12.2792Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTimer);
export default __webpack_public_path__ + "static/media/pending-timer.bf543c2b2df7eef5374e888d5b0a4a07.svg";
export { ForwardRef as ReactComponent };